import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { concat, find, get, result } from 'lodash';

// store
import { AppState } from '../app-reducer';
import { Store } from '@ngrx/store';
import { concatMap, debounceTime, distinctUntilChanged, first, take, tap } from 'rxjs/operators';

// pop up
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { animate, style, transition, trigger } from '@angular/animations';

import { ComposableService } from '../services/composable.service';
import { NavigationService } from '../services/navigation.service';
import { ModalComponent } from 'src/app/components/modal.component';
import { ApiService } from 'src/app/services/api.service';
import { AppConstants } from '../app.constants';
import { ProcessorService } from '../services/processor.service';

@Component({
  selector: 'subheader-component',
  templateUrl: './subheader.component.html',
  styleUrls: [],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('1s ease-out', style({ height: 300, opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: 300, opacity: 1 }),
        animate('1s ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class SubheaderComponent {
  appState$: Observable<any>;
  readyToSend: boolean = false;
  readyToSendStop: boolean = false;
  readyToSign: boolean = false;
  readyToSignStop: boolean = false;
  customerSigned: boolean = false;
  userRole: string;
  unlocked: boolean = false;
  showMe: boolean = false;
  AppId;
  ProposedInsuredEmailAddress;
  ProposedInsuredName;
  showModal = false;
  isDemo = false;
  sectionMenuData: any;
  isError = false;
  disclosuresBlock = 34;
  preAuthInsuredBlock = 33;
  personalInfoBlock = 20;
  juvenileInsBlock = 16;
  declarationsAgentBlock = 48;
  personalFinancialBlock: 17;
  signAndSendButton: boolean;

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private composableService: ComposableService,
    private navigationService: NavigationService,
    private processorService: ProcessorService,
    private apiService: ApiService,
    private changeDetection: ChangeDetectorRef,
    private appConstants: AppConstants

  ) {

    this.appState$ = store.select('sections');
    const currentRoute = find(this.router.config, { path: location.pathname.substring(1) });
    

    this.router.events.pipe(debounceTime(10), distinctUntilChanged()).subscribe ((val) => {
      this.appState$.pipe(
        first()
      ).pipe(
      concatMap((val) => {
      this.appState$.pipe(
        first()
      ).subscribe((state: any) => {
        this.userRole = state.userRole.name;
        this.unlocked = state.unlocked;
        this.customerSigned = state.content.DeclarationsInsured ? state.content.DeclarationsInsured.FinalSignature.trim() ? state.content.DeclarationsInsured.FinalSignature : false : false;
        this.isDemo = state.isDemo;
        this.isError = currentRoute.path.includes('error') ? true : false;
        

        if ((currentRoute.path).includes('demo-welcome')){
          this.isDemo = true;
        }
        if ((currentRoute.path).includes('financial-professional')){
          this.isDemo = false;
          this.changeDetection.detectChanges();
        }
        if ((currentRoute.path).includes('error')){
          this.isDemo = false;
          this.changeDetection.detectChanges();
        }
        // Email Info
        this.AppId = state['content']['ApplicationId'] ? state['content']['ApplicationId'] : state['appId'];
        if (state['content'] && state['content']['SECTIONAProposedInsured']) {
          this.ProposedInsuredEmailAddress = state['content']['SECTIONAProposedInsured']['EmailAddress'];
          const firstName = state['content']['SECTIONAProposedInsured']['Name']['FirstName'];
          const lastName = state['content']['SECTIONAProposedInsured']['Name']['LastName'];
          this.ProposedInsuredName = (firstName && lastName) ? firstName + ' ' + lastName : null;
        }

        this.sectionMenuData = state.content.menuData;
        if (this.sectionMenuData) {
          this.disclosuresBlock = state.content.menuData.findIndex(x => x.name == 'Disclosures');
          this.preAuthInsuredBlock = state.content.menuData.findIndex(x => x.name == 'RequestforPreAuthorizedPaymentPlanInsured');
          this.personalInfoBlock = state.content.menuData.findIndex(x => x.name == 'SECTIONGPersonalInformation');
          this.juvenileInsBlock = state.content.menuData.findIndex(x => x.name == 'SECTIONIJuvenileInsurance');
          this.declarationsAgentBlock = state.content.menuData.findIndex(x => x.name == 'DeclarationsAgent');
          this.personalFinancialBlock = state.content.menuData.findIndex(x => x.name == 'SupplementFinancialPersonal');

        }
      });

      if (!this.userRole.includes('Insured')) {
        if (this.customerSigned) {
          this.readyToSend = false;
          this.readyToSign = this.sectionMenuData ? this.sectionMenuData.every((block, index) => (index < this.declarationsAgentBlock && (block.valid === true || block.visible === false))) : false;
        } else {
          if (this.sectionMenuData) {
            this.readyToSend = !this.readyToSign && this.sectionMenuData.every((block, index) => (index < this.personalInfoBlock && (block.valid === true || block.visible === false)) || index > this.personalFinancialBlock);
            // this.readyToSend = !this.readyToSign && this.sectionMenuData.every((block, index) => (index < 1 && (block.valid === true || block.visible === false)) || index > 0);
            if (this.userRole === 'Omnipotent' && this.readyToSend) {
              this.readyToSign = this.sectionMenuData ? this.sectionMenuData.every((block, index) => (index < this.disclosuresBlock && (block.valid === true || block.visible === false)) || index > this.preAuthInsuredBlock) : false;
              // this.readyToSign = this.sectionMenuData ? this.sectionMenuData.every((block, index) => (index < 4 && (block.valid === true || block.visible === false)) || index > 3) : false;
              if (this.readyToSign) {
                this.readyToSend = false;
              }
            } 
          }
        }
      } else if (this.userRole.includes('Insured')) {
        this.readyToSend = false;
        this.readyToSign = this.sectionMenuData ? this.sectionMenuData.every((block, index) => (index < this.disclosuresBlock && (block.valid === true || block.visible === false)) || index > this.preAuthInsuredBlock) && currentRoute.data.routeIdx < this.disclosuresBlock ? true : false : false;
      }

      if (this.readyToSend && !this.readyToSendStop) {
        if (this.isDemo){
          this.demoReadyToSendModal();
        } else {
          this.readyToSendModal();
        }
          this.readyToSendStop = true;
      }
      if (this.readyToSign && !this.readyToSignStop && this.signAndSendButton) {
        if (this.isDemo){
          this.demoGoSign();
        }else {
          this.goSign();
        }
        this.readyToSignStop = true;
      }
      if (this.isDemo) {
        this.showMe = this.readyToSign || this.readyToSend;
      } else {
        this.showMe = this.isError === false && ((!this.userRole.includes('Insured') && currentRoute.data ? true : false) || (this.userRole.includes('Insured') && this.signAndSendButton));
      }
	  return this.processorService.readyToSign$.pipe();
    })
    ).subscribe(isReadyToSign => {
        this.signAndSendButton = isReadyToSign;
        this.showMe = this.isError === false && ((!this.userRole.includes('Insured') && currentRoute.data ? true : false) || (this.userRole.includes('Insured') && this.signAndSendButton));
        this.changeDetection.detectChanges();
    })
	});
  }

  backToMiniPortal() {
    this.navigationService.fireSubmit(true);
    // erase app memory to prevent old case data from displaying in agent's next case
    this.composableService.resetApplication();
    // go back to mini-portal or debug page
    const destination = this.userRole === 'Agent' ? 'express/financial-professional' : 'express';
    this.router.navigateByUrl(destination);
  }

  triggerModal() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose:  true,
      closeOnNavigation: true,
      data: {
        AppId: this.AppId,
        ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
        ProposedInsuredName: this.ProposedInsuredName,
        size: '',
        // Array of screens
        emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Send application',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'To share this application with ' + this.ProposedInsuredName + ', click "Send" below.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'The email will be sent to ' + this.ProposedInsuredEmailAddress + '.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + this.ProposedInsuredName + ' accesses the e-application, they will be able to:',
                class: this.appConstants.modalLiDefault
              },
              {
                type: 'unordered_list',
                unordered_list: [
                  {
                    type: 'unordered_list_item',
                    content: 'Review completed sections',
                    class: this.appConstants.modalLiDefault
                  },
                  {
                    type: 'unordered_list_item',
                    content: 'Complete any outstanding medical and/or lifestyle questions, and',
                    class: this.appConstants.modalLiDefault
                  },
                  {
                    type: 'unordered_list_item',
                    content: 'Electronically sign the e-application',
                    class: this.appConstants.modalLiDefault
                  },
                ]
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Cancel',
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Send',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              },
            ]
          },
          // Success Screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: 'Success!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'We have sent the application to ' + this.ProposedInsuredName + ' at ' + this.ProposedInsuredEmailAddress + '.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + this.ProposedInsuredName + '  has signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + this.ProposedInsuredName + ' signature in the JH eApp portal.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button',
                label: this.appConstants.eAppPortalLabel,
                clickFunction: 'goToAgentPortal',
                class: this.appConstants.buttonPrimary
              }
            ]
          },
          // Failure Screen
          {
            show: false,
            exit_btn: false,
            error_flag: true,
            content: [
              {
                type: 'title',
                content: this.appConstants.somethingWentWrong,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalError,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Try Again',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonSecondary
                  }
                ]
              }
            ]
          },
          // Fail on retry screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: this.appConstants.technicalIssueTitle,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalFailureMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: this.appConstants.inconvenienceMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          },
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: "Thank you for completing your portion of the application.",
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'In the next 2-3 minutes, ' + this.ProposedInsuredName + ' should receive an email at ' + this.ProposedInsuredEmailAddress + ' that includes a link to their sections of the application.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + this.ProposedInsuredName + ' has electronically signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + this.ProposedInsuredName + "'s signature in the JH eApp portal.",
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }

  readyToSendModal() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose:  true,
      closeOnNavigation: true,
      data: {
        AppId: this.AppId,
        ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
        ProposedInsuredName: this.ProposedInsuredName,
        size: '',
        // Array of screens
        emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Send to proposed insured',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'Thank you for completing the basic application details. You now have the option to electronically share the remaining application questions with the proposed insured, giving them the flexibility to complete on their own schedule.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: `<ul>
                            <li>
                              Select "Send now" if you\'re ready to share the application with the proposed insured
                            </li>
                            <li>
                              Select "Keep working" to continue with the application and use the "send to proposed insured" button if/when you\'re ready to share (the button appears in blue in the upper right-hand corner of the application)
                            </li>
                          </ul>`,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.keepWorkingBtnLabel,
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Send Now',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              },
            ]
          },
          // Success Screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: 'Success!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'We have sent the application to ' + this.ProposedInsuredName + ' at ' + this.ProposedInsuredEmailAddress + '.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + this.ProposedInsuredName + '  has signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + this.ProposedInsuredName + ' signature in the JH eApp portal.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button',
                label: this.appConstants.eAppPortalLabel,
                clickFunction: 'goToAgentPortal',
                class: this.appConstants.buttonPrimary
              }
            ]
          },
          // Failure Screen
          {
            show: false,
            exit_btn: true,
            error_flag: true,
            content: [
              {
                type: 'title',
                content: this.appConstants.somethingWentWrong,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalError,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Try Again',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonSecondary
                  }
                ]
              }
            ]
          },
          // Fail on retry screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: this.appConstants.technicalIssueTitle,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalFailureMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: this.appConstants.inconvenienceMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          },
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: "Thank you for completing your portion of the application.",
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'In the next 2-3 minutes, ' + this.ProposedInsuredName + ' should receive an email at ' + this.ProposedInsuredEmailAddress + ' that includes a link to their sections of the application.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + this.ProposedInsuredName + ' has electronically signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + this.ProposedInsuredName + "'s signature in the JH eApp portal.",
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }
  demoReadyToSendModal() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose:  true,
      closeOnNavigation: true,
      data: {
        AppId: this.AppId,
        ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
        ProposedInsuredName: this.ProposedInsuredName,
        size: '',
        // Array of screens
        emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Send to proposed insured',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'As the test application will demonstrate, the John Hancock eApp gives you the opportunity to electronically share key sections of the application with your customers to finish at their convenience. ',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'A “send” message box will appear once you have entered the required minimum application details. You have three choices on how to respond:',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: '1.	Click the “Send now” button in the pop-up message to immediately share the application with the proposed insured, or'
              },
              {
                type: 'text',
                content: '2.	Close the pop-up message to continue working on the application and use the “send to proposed insured” button when you’re ready to share (the button appears in blue in the upper right-hand corner of the application), or',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: '3.	Close the pop-up message and choose not to send the unfinished sections to the proposed insured. Then, once you’ve completed the application in full, you will be prompted to send it to the proposed insured for their electronic signature',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.keepWorkingBtnLabel,
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Send Now',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              },
            ]
          },
          // Success Screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: 'Success!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'Regardless of when you use the “send” feature, you (the agent) will receive on-screen confirmation that you have successfully sent the application, and your customer will receive an email indicating it is time to complete their application. ',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Reminder: in this test experience, you (the agent) will receive this notification, as you are also assuming the role of customer. Please check your email for applicable next steps.   ',
                class: 'modal-p-ital-bold'
              },
              {
                type: 'button',
                label: this.appConstants.eAppPortalLabel,
                clickFunction: 'goToAgentPortalDemo',
                class: this.appConstants.buttonPrimary
              }
            ]
          },
          // Failure Screen
          {
            show: false,
            exit_btn: false,
            error_flag: true,
            content: [
              {
                type: 'title',
                content: this.appConstants.somethingWentWrong,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalError,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Try Again',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonSecondary
                  }
                ]
              }
            ]
          },
          // Fail on retry screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: this.appConstants.technicalIssueTitle,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalFailureMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: this.appConstants.inconvenienceMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          },
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: "Success!",
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'Regardless of when you use the “send” feature, you (the agent) will receive on-screen confirmation that you have sent the application, and your customer will receive an email indicating it is time to complete their application.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Reminder: in this test experience, you (the agent) will receive this notification, as you are also assuming the role of customer. Please check your email for applicable next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }
  goSign() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose:  true,
      closeOnNavigation: true,
      data: {
        AppId: this.AppId,
        ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
        ProposedInsuredName: this.ProposedInsuredName,
        size: '',
        // Array of screens
        emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Your application is ready to be signed!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.keepWorkingBtnLabel,
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Review and sign',
                    clickFunction: 'goSignApp',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }
  demoGoSign() {
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose:  true,
      closeOnNavigation: true,
      data: {
        AppId: this.AppId,
        ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
        ProposedInsuredName: this.ProposedInsuredName,
        size: '',
        // Array of screens
        emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Your application is ready to be signed!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'Once the proposed insured has completed any remaining application questions, they will receive a pop-up notification letting them know they have completed the required information needed and that their application is ready to be signed. Once this message appears, your customer can choose to go to the signature process or continue working on the application.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Reminder: in this section of test experience, you (the agent) will sign the application, as you are also assuming the role of customer.',
                class: 'modal-p-ital-bold'
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.keepWorkingBtnLabel,
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Review & sign',
                    clickFunction: 'goSignApp',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }
}